<template>
  <div id="layout">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="login">
          <v-text-field prepend-icon="mdi-account" name="login" label="Login" type="text" v-model="username" @keypress="wrongAttempt = false"></v-text-field>
          <v-text-field
            id="password"
            prepend-icon="mdi-textbox-password"
            name="password"
            label="Password"
            type="password"
            v-model="password"
            @keypress="wrongAttempt = false"
            @keypress.enter="doLogin()"
          >
          </v-text-field>
        </v-form>
        <v-alert type="error" border="top" style="margin-top: 10px;" v-if="wrongAttempt">
          Username or password are wrong
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="doLogin" :loading="loading">Login</v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      username: '',
      password: '',
      wrongAttempt: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions(['login']),
    doLogin () {
      this.loading = true
      this.login({ username: this.username, password: this.password })
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => {
          this.wrongAttempt = true
          this.password = ''
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  mounted () {
    if (this.isLoggedIn) {
      this.$router.push('/')
    }
  }
}
</script>
